import sleep from './sleep';
import isAbortError from './is-abort-error';

const defaultAbortErrorChecker = (error) => isAbortError(error);

function withAbortAwareRetry(
  asyncFunc,
  {
    retryCount = 3,
    sleepTime = 3000,
    abortController,
    abortErrorChecker = defaultAbortErrorChecker,
  } = {}
) {
  return async (...params) => {
    let attempt = 0;

    // eslint-disable-next-line no-constant-condition
    while (true) {
      if (abortController?.signal.aborted) {
        throw new DOMException('Aborted', 'AbortError');
      }

      try {
        // eslint-disable-next-line no-await-in-loop
        return await asyncFunc(...params);
      } catch (error) {
        attempt += 1;

        if (abortErrorChecker?.(error)) {
          throw error;
        }

        if (attempt >= retryCount) {
          throw error;
        }

        // eslint-disable-next-line no-await-in-loop
        await sleep(sleepTime);
      }
    }
  };
}

export default withAbortAwareRetry;
